import {getAPIDomain} from '../config/constants'
const loginApiEndPoint = `${getAPIDomain()}/auth/login`;
export const doLogin = async ({email,password}) => {
      return fetch(loginApiEndPoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({email,password})
    }).then(response => response.json())
  .then(data => (data))
  .catch((error) => {
  console.error('Error:', error);
  })
};